module.exports = __webpack_public_path__ + "static/media/logo.18b15ee2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/slider-banners/lucky-chiken/logo.png
// module id = 2467
// module chunks = 7